import React from 'react';
import { Plane } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-slate-300 py-12">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <Plane className="w-6 h-6 text-blue-400" />
              <div className="text-xl font-bold text-white">
                Puro <span className="text-blue-400">Engineering</span>
              </div>
            </div>
            <p className="text-slate-400 leading-relaxed">
              Engineering support for unmanned aviation programs, tailored for rapid iteration and practical execution.
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Services</h3>
            <ul className="space-y-2">
              <li>
                <a href="#services" className="text-slate-400 hover:text-blue-400 transition-colors duration-200">
                  UAS Design & Development
                </a>
              </li>
              <li>
                <a href="#services" className="text-slate-400 hover:text-blue-400 transition-colors duration-200">
                  Build & Integration
                </a>
              </li>
              <li>
                <a href="#services" className="text-slate-400 hover:text-blue-400 transition-colors duration-200">
                  Flight Test Support
                </a>
              </li>
              <li>
                <a href="#services" className="text-slate-400 hover:text-blue-400 transition-colors duration-200">
                  Wiring & Cable Assemblies
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Contact</h3>
            <ul className="space-y-2">
              <li className="text-slate-400">
                info@puroengineering.com
              </li>
              <li className="text-slate-400">
                +1 (480) 433-9160
              </li>
              <li className="text-slate-400">
                United States
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8 text-center">
          <p className="text-slate-400">
            © {currentYear} Puro Engineering. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


